import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
} from "@vinomofo/icons";

import { MARKET_AUDIENCE } from "../../utils/constants";

export const listOne = {
  heading: "What you really want",
  links: [
    {
      label: "All Wines",
      link: "/wines",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Red Wine",
      link: "/wines/red-wines/",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "White Wine",
      link: "/wines/white-wine/",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Mixed Cases",
      link: "/wines/mixed/",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Wine Clubs",
      link: "/wine-clubs",
      isExternal: true,
      audience: MARKET_AUDIENCE.EXCEPTSG,
    },
  ],
};

export const listOneWhiskymofo = {
  heading: "What you really want",
  links: [
    {
      label: "All Spirits",
      link: "/spirits",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Scotch",
      link: "/spirits/scotch/",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Bourbon",
      link: "/spirits/bourbon/",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Japanese",
      link: "/spirits/japanese/",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Gin",
      link: "/spirits/gin/",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Rum",
      link: "/spirits/rum/",
      audience: MARKET_AUDIENCE.ALL,
    },
  ],
};

export const listTwo = {
  heading: "Maybe look at these",
  links: [
    {
      label: "Vinofiles",
      link: "/articles",
      isExternal: true,
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Events",
      link: "/events",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "About us",
      link: "/about",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Contact us",
      link: "/contact",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Jobs",
      link: "/jobs",
      audience: MARKET_AUDIENCE.ALL,
    },
  ],
};

export const listTwoWhiskymofo = {
  heading: "Maybe look at these",
  links: [
    {
      label: "Whiskyfiles",
      link: "/whiskymofo-articles",
      isExternal: true,
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Events",
      link: "/events",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "About us",
      link: "/about",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Contact us",
      link: "/contact",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Jobs",
      link: "/jobs",
      audience: MARKET_AUDIENCE.ALL,
    },
  ],
};

export const listThree = {
  heading: "Other stuff",
  links: [
    {
      label: "Returns",
      link: "/returns",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Shipping",
      link: "/shipping",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Privacy",
      link: "/privacy",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Terms of Use",
      link: "/terms",
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Loyalty FAQs",
      link: "/vim-faqs",
      audience: MARKET_AUDIENCE.EXCEPTSG,
    },
    {
      label: "VIM Terms and Conditions",
      link: "/vim-terms-and-conditions",
      audience: MARKET_AUDIENCE.EXCEPTSG,
    },
  ],
};

export const listFour = {
  heading: "Stalk us",
  links: [
    {
      label: "Facebook",
      link: "https://www.facebook.com/vinomofo",
      icon: <FacebookIcon color="#244f9f" />,
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "Twitter",
      link: "https://twitter.com/vinomofo",
      icon: <TwitterIcon color="#50afed" />,
      audience: MARKET_AUDIENCE.EXCEPTSG,
    },
    {
      label: "Twitter",
      link: "https://twitter.com/vinomofo_sg",
      icon: <TwitterIcon color="#50afed" />,
      audience: MARKET_AUDIENCE.SG,
    },
    {
      label: "Instagram",
      link: "https://instagram.com/vinomofo",
      icon: <InstagramIcon color="#ff6ab0" />,
      audience: MARKET_AUDIENCE.ALL,
    },
    {
      label: "YouTube",
      link: "https://www.youtube.com/user/vinomofo",
      icon: <YoutubeIcon color="#e11a3d" />,
      audience: MARKET_AUDIENCE.ALL,
    },
  ],
};

export const iconList = {
  facebook: <FacebookIcon color="#244f9f" />,
  twitter: <TwitterIcon color="#50afed" />,
  instagram: <InstagramIcon color="#ff6ab0" />,
  youtube: <YoutubeIcon color="#e11a3d" />
};